import { combineReducers } from "redux";
import Post from "./Post";
import User from "./User";
import Toggle from "./Toggle";
import Socket from "./Socket";
export default combineReducers({ Post, User, Toggle, Socket });
